import { useParams } from 'react-router-dom';
import { FileX2 } from 'lucide-react';

import OfferingCard from '@/app/offering/ViewOfferingCard';

import Loader from '@/components/common/Loader';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

import { useOfferings } from '@/data/offering';
import { useOfferingCategories } from '@/data/offeringCategory';

const Offerings = () => {
  const params = useParams();
  const offerings = useOfferings(params.coachActivityId);
  const offeringCategories = useOfferingCategories();

  if (
    (offerings.isLoading && !offerings.data) ||
    (offeringCategories.isLoading && !offeringCategories.data)
  ) {
    return (
      <div className="h-32 flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <h2 className="text-2xl font-bold mb-8">Offerings</h2>
      {offerings.data.query.length === 0 && (
        <Alert>
          <FileX2 className="h-4 w-4" />
          <AlertTitle>No Offerings Found</AlertTitle>
          <AlertDescription>
            The coach has not added any offerings yet.
          </AlertDescription>
        </Alert>
      )}
      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {offerings.data.query.map((offeringId) => {
          const offering = offerings.data.content[offeringId];
          return (
            <li key={offeringId}>
              <OfferingCard offering={offering} />
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default Offerings;
